import React from 'react';

// Declare types for window object
declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

interface GoogleAnalyticsProps {
    gaCode: string;
}

export const GoogleAnalytics: React.FC<GoogleAnalyticsProps> = ({ gaCode }) => {
    React.useEffect(() => {
        // Initialize dataLayer
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
            window.dataLayer.push(arguments);
        };

        // Create and append GA script
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gaCode}`;
        document.head.appendChild(script);

        // Initialize GA
        window.gtag('js', new Date());
        window.gtag('config', gaCode);
    }, [gaCode]);

    return null;
};